export class CatalogListDatabasesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "databases",
            "baseName": "databases",
            "type": "Array<CatalogDatabase>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CatalogListDatabasesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
